export const ratingFilterTagPrefix = 'f-';
export const ratingDetailPagePath = '/rating/';
export const maximumRatingAmount = 5;
